import { events } from './events';
import { pageView } from './pageView';

export const ga = { events, pageView } as const;
